import { TestFillTranslation } from './testFill.translation.en.ts';

export const testFillTranslation: TestFillTranslation = {
  backToCertification: 'Wróć do certyfikacji',
  finish: 'Zakończ',
  finishDialog: {
    cancel: 'Anuluj',
    confirm: 'Zakończ test',
    content:
      'Czy na pewno chcesz zakończyć test? Po potwierdzeniu nie będziesz mieć już możliwości powrotu do edycji poprzednich odpowiedzi.',
    title: 'Zakończyć test?',
  },
  label: 'Test',
  next: 'Dalej',
  notFound: 'Nie znaleziono testu',
  previous: 'Poprzednie',
  progressLabel: 'Postęp',
  questionCounter: 'Pytanie {{current}} z {{total}}',
  questionLabel: 'Pytanie {{number}}',
  rankInstruction: 'Przeciągnij elementy, aby ustawić je w prawidłowej kolejności',
  result: {
    backToCertification: 'Wróć do certyfikacji',
    correctRanking: 'Poprawna kolejność',
    expiredDescription:
      'Czas na rozwiązanie testu dobiegł końca. Test został zakończony automatycznie.',
    failed: 'Niezaliczony',
    noAnswer: 'Brak odpowiedzi',
    passed: 'Zaliczony',
    questionsAccessExpired: 'Czas dostępu do pytań upłynął.',
    questionsAvailableAfterTerm:
      'Szczegóły pytań będą dostępne po automatycznym zakończeniu terminu o {{termEndDatetime}} lub natychmiast po ręcznym zamknięciu terminu przez prowadzącego egzamin.',
    questionsAvailableWindowInfo:
      'Pytania będą dostępne tylko przez {{minutes}} min od zakończenia terminu.',
    questionsRemainingTime: 'Pytania dostępne jeszcze przez: {{time}}',
    questionsTitle: 'Szczegóły pytań',
    score: 'Twój wynik: {{score}}%',
    threshold: 'Próg zdawalności: {{threshold}}%',
    title: 'Wynik testu',
    yourAnswer: 'Twoja odpowiedź',
    yourRanking: 'Twoja kolejność',
  },
  section: 'Obszar: {{name}}',
  submitting: 'Zapisywanie...',
  timeExpired: 'Czas minął',
  timeLeft: 'Pozostały czas: {{time}}',
  unavailable: {
    backToCertification: 'Wróć do certyfikacji',
    cancelledDescription: 'Ten termin testu został anulowany. Nie możesz dalej rozwiązywać testu.',
    completedDescription: 'Ten termin testu został zakończony. Nie możesz już udzielać odpowiedzi.',
    genericDescription:
      'Ten termin testu jest obecnie niedostępny. Skontaktuj się z administratorem.',
    newDescription: 'Ten termin testu jeszcze się nie rozpoczął. Wróć, gdy będzie aktywny.',
    title: 'Termin testu niedostępny',
  },
};
